import { render, staticRenderFns } from "./edit-breadAuth-dialog.vue?vue&type=template&id=23c7909b&scoped=true"
import script from "./edit-breadAuth-dialog.vue?vue&type=script&lang=js"
export * from "./edit-breadAuth-dialog.vue?vue&type=script&lang=js"
import style0 from "./edit-breadAuth-dialog.vue?vue&type=style&index=0&id=23c7909b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c7909b",
  null
  
)

export default component.exports